export default __webpack_public_path__ + "static/media/trading.af18c65d.png";